import './Footer.scss'
import { useEffect } from 'react'
import { Container, Col, Row } from 'react-bootstrap'

import { isInApp } from '../../helpers/Mobile'

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/remble.health',
    icon: 'bi-facebook'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/remble.health/',
    icon: 'bi-instagram'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/remble',
    icon: 'bi-linkedin'
  },
  {
    name: 'Twitter',
    url: 'https://twitter.com/remblehealth',
    icon: 'bi-twitter'
  },
  {
    name: 'Pinterest',
    url: 'https://www.pinterest.com/RembleHealth/',
    icon: 'bi-pinterest'
  }
]

/**
 * Simple Footer component for displaying the footer on web browsers
 * @param {Object} paramObj Dependency object, uses `isAuthenticated` state variable to know if a user is logged in
 */
export default function Footer({ isAuthenticated }) {
  useEffect(() => {}, [isAuthenticated])

  // Don't display the footer if within the mobile app
  if (isInApp()) return null

  return (
    <footer className='footer'>
      <Container>
        <Row>
          <Col>
            {socialLinks.map(({ url, icon }) => (
              <a
                href={url}
                key={url}
                target='_blank'
                rel='noreferrer'
                className='social-link'
              >
                <i className={`bi ${icon}`}></i>
              </a>
            ))}
          </Col>
        </Row>
        <Row>
          <Col className='copyright'>
            © {new Date().getFullYear()} Remble®, Inc. All Rights Reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
